import { usePageMeta } from '../lib/site';
import Legal from './Legal';

const SECTIONS = [
  {
    ps: [
      'These Terms of Service ("Terms") govern your use of the MyGolfLinks app and services, operated by MyGolfLinks, LLC. By creating an account or using the app, you agree to these Terms and to our Privacy Policy.',
    ],
  },
  {
    h: '1. Eligibility and your account',
    ps: [
      'You must be at least 13 years old to use MyGolfLinks, and at least 18 to make purchases. You are responsible for the information you provide, for keeping your password secure, and for all activity under your account. Tell us promptly if you suspect unauthorized use.',
    ],
  },
  {
    h: '2. Acceptable use',
    ps: ['You agree to use MyGolfLinks lawfully and respectfully. You will not:'],
    lis: [
      "Post content that is illegal, harassing, hateful, deceptive, or infringes others' rights.",
      'Misrepresent your identity, scores, or handicap, or interfere with fair competition.',
      "Attempt to disrupt, reverse-engineer, scrape, or gain unauthorized access to the service or other users' data.",
      'Use the service to spam or to sell or transfer your account.',
    ],
  },
  {
    h: '3. Content moderation and zero tolerance',
    ps: [
      'MyGolfLinks has zero tolerance for objectionable content and abusive behavior. Content that is illegal, harassing, hateful, sexually explicit, threatening, or that targets, demeans, or endangers others is not permitted, and neither is abusive, predatory, or bullying conduct toward other golfers.',
      'You can report objectionable content and abusive users, and block another user, directly in the app; look for the Report and Block options on posts, comments, profiles, and messages. We review reports and act on them, typically within 24 hours, by removing content and suspending or permanently banning users who violate these Terms. By using MyGolfLinks you acknowledge and agree to this zero-tolerance policy.',
    ],
  },
  {
    h: '4. Your content',
    ps: [
      'You keep ownership of the content you post (rounds, posts, photos, and so on). You grant MyGolfLinks a non-exclusive license to host, display, and share that content as needed to operate the features you use. You are responsible for the content you post and confirm you have the right to share it.',
    ],
  },
  {
    h: '5. Bookings, deals, and payments',
    ps: [
      "MyGolfLinks lets you reserve tee times, lessons, and deals offered by golf courses and partners. The course or partner is responsible for honoring its offer. Prices, availability, and cancellation terms are shown before you reserve. In the mobile app, you reserve your spot and pay the course directly; no payment is taken in the app. Where a booking is paid online (currently on the web), payment is processed by Stripe and, by paying, you also agree to Stripe's terms. Refunds and cancellations follow the policy shown for that booking.",
    ],
  },
  {
    h: '6. Handicap and scoring',
    ps: [
      'Handicaps, scores, and statistics in the app are for your own tracking and our social features. Unless and until you connect an official source, your index is provisional and is not an official USGA/GHIN World Handicap Index. Do not rely on it for official competition.',
    ],
  },
  {
    h: '7. Third-party services',
    ps: [
      'The app relies on third parties (such as Google for sign-in and Mapbox for maps) and may link to course or partner sites. We are not responsible for third-party services or content, which are governed by their own terms.',
    ],
  },
  {
    h: '8. Disclaimers and limitation of liability',
    ps: [
      'The service is provided "as is" without warranties of any kind. To the fullest extent permitted by law, MyGolfLinks is not liable for indirect, incidental, or consequential damages, and our total liability for any claim relating to the service is limited to the amount you paid us in the 12 months before the claim.',
    ],
  },
  {
    h: '9. Termination',
    ps: [
      'You may stop using MyGolfLinks and delete your account at any time. We may suspend or terminate accounts that violate these Terms or that we must remove to comply with the law or protect the platform.',
    ],
  },
  {
    h: '10. Governing law',
    ps: [
      'These Terms are governed by the laws of the State of Indiana, USA, without regard to its conflict-of-laws rules.',
    ],
  },
  {
    h: '11. Changes to these Terms',
    ps: [
      'We may update these Terms from time to time. When changes are material, we will update the effective date and ask you to review and accept the updated Terms in the app.',
    ],
  },
  {
    h: '12. Contact us',
    ps: ['Questions about these Terms? Email us at hello@mygolflinks.com.'],
  },
];

export default function Terms() {
  usePageMeta('Terms of Service | MyGolfLinks', 'The terms that govern the MyGolfLinks app and services, operated by MyGolfLinks, LLC.');
  return <Legal title="Terms of Service" effective="July 25, 2026" sections={SECTIONS} />;
}
